import React from 'react';
import type { FaixaDePreco } from '../../../../../@types/IPA/PrecoPsicologico';
import { formatCurrencyToPtBr } from '../../../../../utils/currency';
import { LABELS_ARREDONDAMENTO, LABELS_DIGITOS, capitalizar } from '../../constants';

function montarResumo(faixa: FaixaDePreco): string {
  const digitos = capitalizar(LABELS_DIGITOS[faixa.tipo] ?? '');
  const finais = faixa.finaisPermitidos.join(' e ');
  const arredondamento = LABELS_ARREDONDAMENTO[faixa.opcaoArredondamento] ?? '';
  return `${digitos}, final ${finais}, ${arredondamento}.`;
}

interface Props {
  faixas: FaixaDePreco[];
  idSelecionado?: string;
  onSelecionar: (faixa: FaixaDePreco) => void;
  onExcluir: (faixa: FaixaDePreco) => void;
  onAdicionarNova: () => void;
}

export function FaixaDePrecoList({ faixas, idSelecionado, onSelecionar, onExcluir, onAdicionarNova }: Props) {
  const ordenadas = [...faixas].sort((a, b) => a.valorDe - b.valorDe);

  return (
    <div className="prl">
      <div className="prl__header-card">
        <div className="prl__titulo-row">
          <span className="prl__titulo">Faixas de preço</span>
          <span className="prl__subtitulo">Crie regras de arredondamento para diferentes faixas de preço</span>
        </div>
      </div>

      {ordenadas.map(faixa => (
        <div
          key={faixa.id}
          className={`prl__card ${idSelecionado === faixa.id ? 'prl__card--selecionado' : ''}`}
          onClick={() => onSelecionar(faixa)}
        >
          <div className="prl__card-info">
            <div className="prl__card-faixa">
              {formatCurrencyToPtBr(faixa.valorDe)} a {formatCurrencyToPtBr(faixa.valorAte)}
            </div>
            <div className="prl__card-resumo">{montarResumo(faixa)}</div>
          </div>
          <div className="prl__card-acoes">
            <button
              className="prl__link-btn"
              type="button"
              onClick={e => { e.stopPropagation(); onSelecionar(faixa); }}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); onSelecionar(faixa); } }}
            >
              Editar
            </button>
            <button
              className="prl__link-btn prl__link-btn--perigo"
              type="button"
              onClick={e => { e.stopPropagation(); onExcluir(faixa); }}
            >
              Excluir
            </button>
          </div>
        </div>
      ))}

      {ordenadas.length === 0 && (
        <div className="prl__nova-faixa">
          <div className="prl__nova-faixa-conteudo">
            <span className="prl__nova-faixa-titulo">Nova faixa</span>
            <span className="prl__nova-faixa-sub">Salve as configurações</span>
          </div>
        </div>
      )}

      <button className="prl__adicionar" type="button" onClick={onAdicionarNova}>
        <svg className="prl__adicionar-icone" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
        <span>Adicionar nova regra</span>
      </button>
    </div>
  );
}
